module.exports = __webpack_public_path__ + "static/img/PC-1.e4944ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/PC-1.png
// module id = XGUc
// module chunks = 0